import * as CryptoJS from 'crypto-js';
import { environment } from 'environments/environment';

function containsQuestionMark(s: string): boolean {
    return s.indexOf('?') !== -1;
  }
  
  function capitalizeAllWords(s: string): string {
    return s.replace(/\b\w/g, l => l.toUpperCase());
  }
  
  export function withReturnUrl(url: string, returnUrl: string, query?: string): string {
    query = query || '';
    if (containsQuestionMark(returnUrl) && containsQuestionMark(query)) {
      query = `&${query.substr(1, query.length)}`;
    }
    return `${url}?returnurl=${encodeURIComponent(returnUrl + query)}`;
  }
  
  export const MEMBER_BENEFITS_URL = 'https://www.ama-assn.org/member-benefits';
  export const MEMBER_BENEFITS_PLUS_URL = 'https://www.ama-assn.org/ama-member-benefits-plus';
  
  export function cleanUrlPageName(url: string): string {
    const cleanedUrl = url.replace('/', '').replace('-', ' ');
    return capitalizeAllWords(cleanedUrl);
  }
  
  export function encrypt(data: string): string {
    return CryptoJS.AES.encrypt(data, environment.ocmCryptoKey).toString();
  }

  export function decrypt(data: string): string {
    const bytes = CryptoJS.AES.decrypt(data, environment.ocmCryptoKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  }